import http from '../request/request.js';

export default {
  //登录
	userLogin:function(params){
		return http.fetchPost('/ProjectUsr/ProjectUsrLogin', params)
	},
	//修改密码
	getSetPwd:function(params){
		return http.fetchPost('/ProjectUsr/ProjectUsrPwdUpdate',params)
	},
	//退出
	UsrLogout:function(params){
		return http.fetchPost('/ProjectUsr/ProjectUsrLogout',params)
	},
  //菜单列表
	MenuList:function(params){
		return http.fetchPost('/Menu/MenuList',params)
	},
  // 操作类型
  GetOprTypeList:function(params){
		return http.fetchPost('/BaseModel/GetOprTypeList', params)
	},
  // 订单状态
  GetCurStateList:function(params){
		return http.fetchPost('/BaseModel/GetCurStateList', params)
	},
  // 审核状态
  GetExamineStateList:function(params){
		return http.fetchPost('/BaseModel/GetExamineStateList', params)
	},
  //心贴发单列表
	getHeartOrderList:function(params){
		return http.fetchPost('/HeartOrder/HeartOrderList', params)
	},
	//修改订单上传信息
	updateHeartOrder:function(params){
		return http.fetchPost('/HeartOrder/HeartOrderUpdate', params)
	},
  //删除订单
	delHeartOrder:function(params){
		return http.fetchPost('/HeartOrder/HeartOrderDelete', params)
	},
  getCodeList(params){
    return http.fetchPost('/Pub/GetMiscodeList', params)
  },
  getHeartCodeList(params){
    return http.fetchPost('/Pub/DocHeartCodeList', params)
  },
  ExportHeartOrderData(params){
    return http.fetchPost('/HeartOrder/ExportHeartOrderData', params)
  },
  //心贴获取待审核列表
  OrderHeartMatchList: function (params) {
      return http.fetchPost('/HeartRecord/HeartRecordWaitList', params)
  },
  //获取绘制心电图地址
  getHeartPicUrl(params) {
      return http.fetchPost('/Pub/CreateHeartHttp', params)
  },
  // 操作记录
  HeartOrderOprLogList(params) {
      return http.fetchPost('/HeartOrder/HeartOrderOprLogList', params)
  },
  // 记录列表
  HeartRecordList:function(params){
		return http.fetchPost('/HeartRecord/HeartRecordList', params)
	},
  // 下载报告
  HeartRecordReport:function(params){
		return http.fetchPost('/HeartRecord/HeartRecordReport', params)
	},
  // 下载报告
  HeartRecordDownload:function(params){
		return http.fetchPost('/2016-08-15/proxy/pdfcache.LATEST/ULInfPdfDownFu/', params,'https://1546043903304782.cn-beijing.fc.aliyuncs.com',true)
	},

}



// WEBPACK FOOTER //
// ./src/service/ApiService.js